import { ToggleGroup, ToggleGroupOption } from '@retail/components';
import { useProductsTFunction } from '@retail/products/i18n';
import { IncludesOrMissing } from '@retail/products/types';
import { useMemo } from 'react';

interface Props {
  includeOrMissingFieldValue: IncludesOrMissing;
  switchIncludeOrMissingFieldValue: (value: IncludesOrMissing) => void;
}

export function IncludesOrMissingFieldToggleGroup({
  includeOrMissingFieldValue,
  switchIncludeOrMissingFieldValue,
}: Props) {
  const t = useProductsTFunction();

  const options: ToggleGroupOption<IncludesOrMissing>[] = useMemo(
    () => [
      { label: t('products.insightReport.includedFields'), value: 'INCLUDES' },
      { label: t('products.insightReport.missingFields'), value: 'MISSING' },
    ],
    [t]
  );

  return (
    <ToggleGroup
      variant="pill"
      label={t('products.insightReport.filterFor')}
      labelDirection="vertical"
      fullWidth
      size="small"
      options={options}
      value={includeOrMissingFieldValue}
      onChange={switchIncludeOrMissingFieldValue}
    />
  );
}
